import { useGetHistorySeller } from '@/hooks/useCustomer';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { format } from 'date-fns';
import { vi } from 'date-fns/locale';
import { User, Calendar, ArrowRight } from 'lucide-react';
import LoadingCircle from '@/components/LoadingCircle';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

const HistoryChange = ({
  idHistorySeller,
  onClose,
  isOpen,
}: {
  idHistorySeller: string | null;
  onClose: () => void;
  isOpen: boolean;
}) => {
  const { data: historySeller, isLoading } =
    useGetHistorySeller(idHistorySeller);

  const formatDate = (dateString: string) => {
    if (!dateString) return '—';
    return format(new Date(dateString), 'dd/MM/yyyy HH:mm', { locale: vi });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="min-w-[900px] max-h-[80vh] overflow-y-auto luxury-theme">
        <DialogDescription className="sr-only">
          Lịch sử thay đổi nhân viên phụ trách
        </DialogDescription>
        <DialogHeader className="luxury-header">
          <DialogTitle className="luxury-title">
            Lịch sử thay đổi nhân viên phụ trách
          </DialogTitle>
        </DialogHeader>
        <div className="mb-4">
          {isLoading ? (
            <div className="flex items-center justify-center h-40">
              <LoadingCircle />
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-[180px]">Thời gian</TableHead>
                  <TableHead>Nhân viên cũ</TableHead>
                  <TableHead className="w-[50px]"></TableHead>
                  <TableHead>Nhân viên mới</TableHead>
                  <TableHead>Thay đổi bởi</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {historySeller?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} className="text-center pt-10">
                      Không có dữ liệu
                    </TableCell>
                  </TableRow>
                ) : (
                  historySeller?.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell className="font-medium">
                        <div className="flex items-center space-x-2">
                          <Calendar className="w-4 h-4 text-luxury-600" />
                          <span>{formatDate(item.changedAt)}</span>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="flex items-center space-x-2">
                          <User className="w-4 h-4 text-luxury-600" />
                          <span>{item.oldSeller.name}</span>
                        </div>
                      </TableCell>
                      <TableCell className="text-center">
                        <ArrowRight className="w-4 h-4 text-luxury-600 mx-auto" />
                      </TableCell>
                      <TableCell>
                        <div className="flex items-center space-x-2">
                          <User className="w-4 h-4 text-luxury-600" />
                          <span>{item.newSeller.name}</span>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="flex items-center space-x-2">
                          <User className="w-4 h-4 text-luxury-600" />
                          <span>{item.changedBy.name}</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HistoryChange;
